<template>
  <div id="footer">
    <div class="pagebottom">
      <div class="footer">
        <div class="footer-left">
          <img src="../assets/logo2.png" class="bussinessLogo" />
        </div>

        <div class="footer-mid">
          <ul>
            <li>首页</li>

            <li>|</li>

            <li>产品</li>

            <li>|</li>

            <li>案例</li>

            <li>|</li>

            <li>商务方式</li>

            <li>|</li>

            <li>关于我们</li>

            <li>|</li>

            <li>加入我们</li>
          </ul>

          <p>
            <span>广州好酷信息科技有限公司</span>

            <span>联系电话：020-39106900</span>
          </p>

          <p>
            <span
              >联系地址：广州番禺区番禺大道北555号番禺节能科技园创新大厦618</span
            >
          </p>

          <p>
            <span>展厅地址：广州番禺迎新东路星力动漫游戏产业园J128</span>
          </p>

          <p>
            <span>
              版权所有：Copyright 2016 - 2020 好酷科技. All Rights Reserved |
              <a href="http://beian.miit.gov.cn/" target="_blank"
                >粤ICP备16091001号</a
              >
            </span>
          </p>
        </div>

        <div class="footer-right">
          <img src="../assets/n.png" class="Code" />

          <div>微信公众号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer",

  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped type="text/css">
/* footer */
.pagebottom {
  width: 100%;
  background-color: #333333;
  display: flex;
  justify-content: center;
}
.footer {
  width: 70vw;
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}
.footer a {
  color: inherit;
  text-decoration: none;
}
.footer-mid {
  padding: 0 2rem;
}
.footer-mid ul {
  display: flex;
  color: #cbcbcb;
  align-items: center;
}
.footer-mid p {
  color: #a5a5a5;
}
.footer-mid span {
  padding-right: 10px;
  font-size: 14px;
}
.footer-mid ul li {
  padding: 0 1rem;
}
.footer-mid ul li:first-child {
  padding-left: 0;
}
.footer-right {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// Footer.vue?be474726